// extracted by mini-css-extract-plugin
export default {"horizontal":"RangePicker_horizontal__KVdsV","vertical":"RangePicker_vertical__8Ic0l"};